//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LanguageListInput from './LanguageListInput';

export default {
  name: 'LanguageList',
  components: { LanguageListInput },
  props: {
    isEdit: { type: Boolean, default: false },
    jobPositionId: { type: String, default: '' },
    dataForm: { type: [Array, Object], default: () => {} },
  },
  data() {
    return {
      dataFormList: this.dataForm,
      itemData: {
        languageName: '',
        listen: 0,
        speak: 0,
        read: 0,
        write: 0,
        typing: 0,
      },
    };
  },
  methods: {
    // 編輯時 新增編輯語言
    updateItem(item) {
      if (!item.languageName) {
        return this.$message.error('請輸入語言名稱');
      }

      // 已有語言(有id)打編輯api, 否則新增
      if (item.id) {
        this.$api('updateOwnerJobLanguage', {
          ...item,
          jobPositionId: this.jobPositionId,
        })
          .then(() => {
            this.$message.success(`編輯語言要求成功!`);
            this.$emit('getLanguageList');
          })
          .catch(error => {
            this.$message.warning(`編輯語言要求失敗! ${error.message}`);
          });
      } else {
        this.$api('addOwnerJobLanguage', {
          ...item,
          jobPositionId: this.jobPositionId,
        })
          .then(() => {
            this.$message.success(`新增語言要求成功!`);
            this.$emit('getLanguageList');
          })
          .catch(error => {
            this.$message.warning(`新增語言要求失敗! ${error.message}`);
          });
      }
    },
    removeItem(item, index) {
      if (item.id) {
        this.$api('removeOwnerJobLanguage', { id: item.id })
          .then(() => {
            this.$message.success(`刪除語言要求成功!`);
            this.$emit('getLanguageList');
          })
          .catch(error => {
            this.$message.warning(`刪除語言要求失敗! ${error.message}`);
          });
      }
      let newList = this.dataFormList.splice(index, 1);
      this.dataFormList = newList;
    },
    addItem() {
      const itemData = Object.assign(
        {},
        this.$options.data.call(this).itemData,
      );

      this.dataFormList.push(itemData);
    },
  },
  watch: {
    dataForm() {
      this.dataFormList = this.dataForm;
    },
  },
};
